/**
 * Inline icon set for the Compose editor, ported from the design
 * prototype's Icon atom. 24px viewBox, stroke = currentColor; sized via
 * the `.ci` class in compose.css.
 */
import type { SVGProps } from 'react';

const base: SVGProps<SVGSVGElement> = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  className: 'ci',
  'aria-hidden': true,
};

export const IconSparkle = () => (
  <svg {...base}><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3z" /></svg>
);
export const IconImage = () => (
  <svg {...base}><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><polyline points="21 15 16 10 5 21" /></svg>
);
export const IconType = () => (
  <svg {...base}><polyline points="4 7 4 4 20 4 20 7" /><line x1="9" y1="20" x2="15" y2="20" /><line x1="12" y1="4" x2="12" y2="20" /></svg>
);
export const IconPointer = () => (
  <svg {...base}><path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z" /></svg>
);
export const IconLayers = () => (
  <svg {...base}><polygon points="12 2 2 7 12 12 22 7 12 2" /><polyline points="2 17 12 22 22 17" /><polyline points="2 12 12 17 22 12" /></svg>
);
export const IconArrowLeft = () => (
  <svg {...base}><line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" /></svg>
);
export const IconArrowRight = () => (
  <svg {...base}><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>
);
export const IconX = () => (
  <svg {...base}><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
);
export const IconCheck = () => (
  <svg {...base}><polyline points="20 6 9 17 4 12" /></svg>
);
export const IconPlus = () => (
  <svg {...base}><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
);
export const IconTrash = () => (
  <svg {...base}><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" /></svg>
);
export const IconCopy = () => (
  <svg {...base}><rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" /></svg>
);
export const IconBook = () => (
  <svg {...base}><path d="M4 19.5A2.5 2.5 0 016.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" /></svg>
);
export const IconMagnifier = () => (
  <svg {...base}><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
);
export const IconDownload = () => (
  <svg {...base}><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>
);
export const IconWand = () => (
  <svg {...base}><path d="M15 4V2M15 10V8M11 6H9M21 6h-2M18.5 3.5l-1.4 1.4M18.5 8.5l-1.4-1.4M4 20l11-11" /></svg>
);
export const IconAlign = () => (
  <svg {...base}><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="15" y2="12" /><line x1="3" y1="18" x2="18" y2="18" /></svg>
);
export const IconForward = () => (
  <svg {...base}><polyline points="9 5 16 12 9 19" /><line x1="16" y1="5" x2="16" y2="19" /></svg>
);
export const IconBackward = () => (
  <svg {...base}><polyline points="15 5 8 12 15 19" /><line x1="8" y1="5" x2="8" y2="19" /></svg>
);
export const IconUpload = () => (
  <svg {...base}><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>
);
export const IconContrast = () => (
  <svg {...base}><circle cx="12" cy="12" r="9" /><path d="M12 3a9 9 0 010 18z" fill="currentColor" stroke="none" /></svg>
);
export const IconReadable = () => (
  <svg {...base}><rect x="3" y="4" width="18" height="16" rx="3" /><path d="M8.5 16l3.5-8 3.5 8M9.9 13.2h4.2" /></svg>
);
export const IconEdges = () => (
  <svg {...base}><rect x="3" y="3" width="18" height="18" rx="6" strokeDasharray="3 3.5" /><rect x="8.5" y="8.5" width="7" height="7" rx="2" /></svg>
);
export const IconCrop = () => (
  <svg {...base}><path d="M6 2v14a2 2 0 002 2h14" /><path d="M18 22V8a2 2 0 00-2-2H2" /></svg>
);
export const IconShape = () => (
  <svg {...base}><polygon points="5 4 19 7 20 15 9 20 4 12" /></svg>
);
export const IconScissors = () => (
  <svg {...base}><circle cx="6" cy="6" r="3" /><circle cx="6" cy="18" r="3" /><line x1="20" y1="4" x2="8.12" y2="15.88" /><line x1="14.47" y1="14.48" x2="20" y2="20" /><line x1="8.12" y1="8.12" x2="12" y2="12" /></svg>
);
export const IconRotate = () => (
  <svg {...base}><polyline points="23 4 23 10 17 10" /><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" /></svg>
);
export const IconTextFlow = () => (
  <svg {...base}><line x1="3" y1="4" x2="21" y2="4" /><line x1="3" y1="9" x2="21" y2="9" /><circle cx="7" cy="15.5" r="3.5" /><line x1="14.5" y1="14" x2="21" y2="14" /><line x1="14.5" y1="18" x2="21" y2="18" /></svg>
);
export const IconWarning = () => (
  <svg {...base}><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>
);
